const messages={
    "zh-CN":{
        title:"中文",
        name:"小明",
        navMy:"个人中心",
        pwd:"修改密码",
        hint:"欢迎使用小明开源的：vue3.0-admin",
        btnZh:"切换中文",
        btnEn:"切换英文"
    },
    "en-US":{
        title:"English",
        name:"Xiao Ming",
        navMy:"Personal",
        pwd:"Change Password",
        hint:"welcome to use Xiao Ming open source vue3.0-admin",
        btnZh:"change Chinese",
        btnEn:"change English"
    }
};
export default messages;